import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const District = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const [orderUser] = usePosOrderUser();

  return (
    <Textfield
      ref={register({})}
      defaultValue={orderUser?.district}
      label={t("posOrders.district")}
      name="order_user.district"
    />
  );
};

export default District;
